import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { EnvironmentId } from '@/react/portainer/environments/types';
import { ContainerId } from '@/react/docker/containers/types';
import { withError } from '@/react-tools/react-query';

import { EdgeStack } from '../../types';

import { logsStatusQueryKey } from './useLogsStatus';

export function useCollectLogsMutation() {
  const queryClient = useQueryClient();

  return useMutation(collectLogs, {
    onSuccess(_, variables) {
      return queryClient.invalidateQueries(logsStatusQueryKey(variables));
    },
    ...withError('Unable to start logs collection'),
  });
}

interface CollectLogs {
  edgeStackId: EdgeStack['Id'];
  environmentId: EnvironmentId;
  containerId?: ContainerId;
  since?: number;
  until?: number;
  tail?: string;
}

async function collectLogs({
  edgeStackId,
  environmentId,
  containerId,
  since,
  until,
  tail,
}: CollectLogs) {
  try {
    await axios.put(
      `/edge_stacks/${edgeStackId}/logs/${environmentId}`,
      {},
      {
        params: { container_id: containerId, since, until, tail },
      }
    );
  } catch (error) {
    throw parseAxiosError(error as Error, 'Unable to start logs collection');
  }
}
